export const cleanPageUrl = () => `${window.location.origin}${window.location.pathname}`;

export const cleanReferrer = () => {
  if (!document.referrer) return '';
  try {
    // Only the source origin is needed; referrer paths can also contain PII.
    return `${new URL(document.referrer).origin}/`;
  } catch {
    return '';
  }
};

export const clearGaCookies = () => {
  let cookies;
  try { cookies = document.cookie; } catch { return; }
  const names = cookies.split(';').map((entry) => entry.trim().split('=')[0])
    .filter((name) => name === '_ga' || name.startsWith('_ga_'));
  const parts = window.location.hostname.split('.');
  const domains = new Set(['', window.location.hostname]);
  // Includes the registrable parent on multi-part suffixes such as co.uk.
  for (let index = 0; index < parts.length - 1; index += 1) {
    domains.add(`.${parts.slice(index).join('.')}`);
  }
  for (const name of names) {
    for (const domain of domains) {
      try {
        document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain ? `; domain=${domain}` : ''}`;
      } catch { /* Cookie access can be disabled by the browser. */ }
    }
  }
};